var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-xl modal-dialog-scrollable" },
            [
              _c(
                "div",
                {
                  staticClass: "modal-content",
                  staticStyle: { height: "calc(100vh - 50px)" },
                },
                [
                  _c("div", { staticClass: "modal-header" }, [
                    _c("h5", { staticClass: "modal-title" }, [
                      _vm._v("Manage "),
                      _c("span", { staticClass: "text-lowercase" }, [
                        _vm._v(_vm._s(_vm.alternativesLabel)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button" },
                        on: { click: _vm.closeDialog },
                      },
                      [_vm._v("×")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body" }, [
                    _vm.initialized === false
                      ? _c("h2", [
                          _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                          _vm._v(" Loading..."),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.initialized
                      ? _c("div", [
                          _c(
                            "ul",
                            {
                              staticClass: "nav nav-tabs",
                              attrs: { role: "tablist" },
                            },
                            [
                              _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link",
                                    class: {
                                      active: _vm.activeTab === "Alternatives",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.activeTab = "Alternatives"
                                      },
                                    },
                                  },
                                  [_vm._v("Select")]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link",
                                    class: {
                                      active: _vm.activeTab === "Template",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.activeTab = "Template"
                                      },
                                    },
                                  },
                                  [_vm._v("Define description")]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "tab-content" }, [
                            _c(
                              "div",
                              {
                                staticClass: "tab-pane pt-3",
                                class: {
                                  active: _vm.activeTab === "Alternatives",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "alert alert-info alert-dismissible",
                                    attrs: { role: "alert" },
                                  },
                                  [
                                    _vm._m(0),
                                    _vm._v(
                                      "\n                                    Select which "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "text-lowercase italic" },
                                      [_vm._v(_vm._s(_vm.alternativesLabel))]
                                    ),
                                    _vm._v(
                                      " are included in your panel.\n                                    You can use the filter or search to find the "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "text-lowercase italic" },
                                      [_vm._v(_vm._s(_vm.alternativesLabel))]
                                    ),
                                    _vm._v(
                                      " you want to include,\n                                    then check the "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "text-lowercase italic" },
                                      [_vm._v(_vm._s(_vm.alternativesLabel))]
                                    ),
                                    _vm._v(
                                      "\n                                    you want (one-by-one or in bulk using the gear-wheel).\n                                    "
                                    ),
                                    _c("strong", [
                                      _vm._v("WARNING: New "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "text-lowercase italic",
                                        },
                                        [_vm._v(_vm._s(_vm.alternativesLabel))]
                                      ),
                                      _vm._v(
                                        " won't be included in panels automatically."
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-6" }, [
                                    _c("div", { staticClass: "dropdown" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "btn btn-outline-secondary btn-lg btn-block",
                                          attrs: { "data-toggle": "dropdown" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                Filter by: " +
                                              _vm._s(
                                                _vm.filterLabel ?? "None"
                                              ) +
                                              "\n                                                "
                                          ),
                                          _c("span", { staticClass: "caret" }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "dropdown-menu",
                                          staticStyle: {
                                            width: "100%",
                                            "max-height": "250px",
                                            "overflow-y": "auto",
                                          },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: { click: _vm.clearFilter },
                                            },
                                            [_vm._v("No filter")]
                                          ),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass: "dropdown-divider",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: { click: _vm.filterIncluded },
                                            },
                                            [_vm._v("Included in the survey")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: { click: _vm.filterExcluded },
                                            },
                                            [
                                              _vm._v(
                                                "Not included in the survey"
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass: "dropdown-divider",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-header" },
                                            [_vm._v("Filter by status:")]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(_vm.statuses, function (s) {
                                            return _c(
                                              "a",
                                              {
                                                key: s.Id,
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.filterByStatus(
                                                      s.Id,
                                                      s.Name
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                    " +
                                                    _vm._s(s.Name) +
                                                    "\n                                                "
                                                ),
                                              ]
                                            )
                                          }),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass: "dropdown-divider",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-header" },
                                            [_vm._v("Filter by list:")]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(_vm.lists, function (l) {
                                            return _c(
                                              "a",
                                              {
                                                key: l.Id,
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.filterByList(
                                                      l.Id,
                                                      l.Name
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                    " +
                                                    _vm._s(l.Name) +
                                                    "\n                                                "
                                                ),
                                              ]
                                            )
                                          }),
                                        ],
                                        2
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-6" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "input-group input-group-lg",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.searchPhrase,
                                              expression: "searchPhrase",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "search",
                                            placeholder: "Search...",
                                          },
                                          domProps: { value: _vm.searchPhrase },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.searchPhrase =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm._m(1),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _vm.filtering === true
                                  ? _c("h3", [_vm._v("Loading...")])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.filtering === false
                                  ? _c(
                                      "table",
                                      { staticClass: "table table-bordered" },
                                      [
                                        _c("thead", [
                                          _c("tr", [
                                            _c(
                                              "th",
                                              {
                                                staticClass: "text-center",
                                                staticStyle: { width: "45px" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "dropdown" },
                                                  [
                                                    _vm._m(2),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "dropdown-menu",
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "dropdown-item",
                                                            on: {
                                                              click:
                                                                _vm.includeAll,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Include all listed below"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "dropdown-item",
                                                            on: {
                                                              click:
                                                                _vm.excludeAll,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Exclude all listed below"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("th", [_vm._v("Name")]),
                                            _vm._v(" "),
                                            _c("th", [_vm._v("Status")]),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "tbody",
                                          _vm._l(
                                            _vm.alternativesView,
                                            function (a) {
                                              return _c("tr", { key: a.Id }, [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-center",
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "text-primary",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            a.IsIncluded =
                                                              !a.IsIncluded
                                                          },
                                                        },
                                                      },
                                                      [
                                                        a.IsIncluded === true
                                                          ? _c("i", {
                                                              staticClass:
                                                                "fa-solid fa-square-check",
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        a.IsIncluded === false
                                                          ? _c("i", {
                                                              staticClass:
                                                                "fa-regular fa-square",
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(a.Name) +
                                                      "\n                                            "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(a.StatusName) +
                                                      "\n                                            "
                                                  ),
                                                ]),
                                              ])
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "tab-pane pt-3",
                                class: { active: _vm.activeTab === "Template" },
                              },
                              [
                                _vm.previewMode === true
                                  ? _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-end",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-sm btn-secondary",
                                              on: {
                                                click: function ($event) {
                                                  _vm.previewMode = false
                                                },
                                              },
                                            },
                                            [_vm._v("Edit template")]
                                          ),
                                          _vm._v(" "),
                                          _vm.includedAlternatives?.length
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "dropdown ml-1",
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-sm btn-outline-secondary dropdown-toggle",
                                                      attrs: {
                                                        "data-toggle":
                                                          "dropdown",
                                                      },
                                                    },
                                                    [_vm._v("Preview")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-menu dropdown-menu-right",
                                                      staticStyle: {
                                                        "overflow-y": "auto",
                                                        "max-height": "400px",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.includedAlternatives,
                                                      function (a) {
                                                        return _c(
                                                          "a",
                                                          {
                                                            key: a.Id,
                                                            staticClass:
                                                              "dropdown-item",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.showDescriptionPreview(
                                                                  a.Id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                    " +
                                                                _vm._s(a.Name) +
                                                                "\n                                                "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.alternativeDescriptionPreview
                                          ),
                                        },
                                      }),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.previewMode === false
                                  ? _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-end",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "dropdown" },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-sm btn-secondary dropdown-toggle",
                                                  attrs: {
                                                    "data-toggle": "dropdown",
                                                  },
                                                },
                                                [_vm._v("Insert")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "dropdown-menu dropdown-menu-right",
                                                  staticStyle: {
                                                    "overflow-y": "auto",
                                                    "max-height": "400px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.insertIntoDescriptionTemplate(
                                                            "Description"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Description")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.insertIntoDescriptionTemplate(
                                                            "Status"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Status")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.attributes,
                                                    function (attr) {
                                                      return _c(
                                                        "a",
                                                        {
                                                          key: attr.Id,
                                                          staticClass:
                                                            "dropdown-item",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.insertIntoDescriptionTemplate(
                                                                attr.Name
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                    " +
                                                              _vm._s(
                                                                attr.Name
                                                              ) +
                                                              "\n                                                "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.includedAlternatives?.length
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "dropdown ml-1",
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-sm btn-outline-secondary dropdown-toggle",
                                                      attrs: {
                                                        "data-toggle":
                                                          "dropdown",
                                                      },
                                                    },
                                                    [_vm._v("Preview")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-menu dropdown-menu-right",
                                                      staticStyle: {
                                                        "overflow-y": "auto",
                                                        "max-height": "400px",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.includedAlternatives,
                                                      function (a) {
                                                        return _c(
                                                          "a",
                                                          {
                                                            key: a.Id,
                                                            staticClass:
                                                              "dropdown-item",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.showDescriptionPreview(
                                                                  a.Id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                    " +
                                                                _vm._s(a.Name) +
                                                                "\n                                                "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.descriptionTemplate,
                                              expression: "descriptionTemplate",
                                            },
                                          ],
                                          ref: "descriptionTemplateTextArea",
                                          staticClass: "form-control",
                                          attrs: { rows: "5" },
                                          domProps: {
                                            value: _vm.descriptionTemplate,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.descriptionTemplate =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("small", {
                                          staticClass: "form-text text-muted",
                                        }),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button" },
                        on: { click: _vm.handleConfirm },
                      },
                      [_vm._v("Save & Close")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        attrs: { type: "button" },
                        on: { click: _vm.closeDialog },
                      },
                      [_vm._v("Close")]
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "alert",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", {
          staticClass: "fa-solid fa-magnifying-glass",
          attrs: { "aria-hidden": "true" },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      { staticClass: "text-primary", attrs: { "data-toggle": "dropdown" } },
      [_c("i", { staticClass: "fa fa-cog fa-lg" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }